import { CircularProgress, Fade } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid-pro';
import React from 'react';

/**
 * Instead of using MUI's default loading overlay with only a circular progress, this adds
 * a background blur effect over the entire grid.
 */
export const DataGridLoadingOverlay = () => (
  <Fade in={true} timeout={300}>
    <GridOverlay
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(2px)',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      <CircularProgress />
    </GridOverlay>
  </Fade>
);
